/**
 * Created by Ning Jiang on 2022-01-14.
 */
import {IdleAnimationController} from "../IdleAnimationController";
import {gsap, TimelineLite} from "gsap";
import {MathHelper} from "@nolimitcity/slot-game/bin/utils/MathHelper";
import {DevilsCrossRoad} from "../../DevilsCrossRoad";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/utils/ArrayHelper";

export class MainFrameIdleController extends IdleAnimationController {

    private _idleNames = ["glow_slow", "glow_fast", "big_glow_fast", "big_glow_slow"];
    private _isPlaying:boolean = false;

    private _startDelay:number = 5;
    private _intervalRange:[number, number] = [5, 15];
    private _mainTl:TimelineLite | null;

    constructor() {
        super();
    }

    public start():void {
        if(this._isPlaying) {
            return;
        }

        this._isPlaying = true;
        this._mainTl = gsap.timeline();
        this._mainTl.add(() => this.playAnimation(), this._startDelay);
    }

    public stop():void {
        this._isPlaying = false;
        if(this._mainTl) {
            this._mainTl.pause();
            this._mainTl.kill();
        }
        this._mainTl = null;
    }

    private playAnimation():void {
        if(!this._isPlaying) {
            return;
        }

        this._mainTl = gsap.timeline();
        this._mainTl.add(this.playFrameGlow());
        this._mainTl.add(() => this.playAnimation(), MathHelper.randomNumberInRange(this._intervalRange[0], this._intervalRange[1], 2));
    }

    private playFrameGlow():TimelineLite {
        const tl = gsap.timeline();
        const entry = DevilsCrossRoad.backgroundElements.setMainFrame(ArrayHelper.getRandomValue(this._idleNames), false);
        if(entry) {
            tl.add(() => {DevilsCrossRoad.backgroundElements.setMainFrame("glow_static", false);}, entry?.animation.duration);
        }
        return tl;
    }
}